import axios from 'axios';
// config
import { HOST_API } from '../config';
import { PATH_DASHBOARD } from 'src/routes/paths';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: HOST_API,
});

const resolveDynamicPath = (pathStr, contextObj) => {
  if (!pathStr || !pathStr.startsWith('PATH_DASHBOARD')) return null;

  const keys = pathStr.split('.').slice(1); // remove "PATH_DASHBOARD"
  return keys.reduce((acc, key) => (acc ? acc[key] : null), contextObj);
};

axiosInstance.interceptors.request.use((config) => {
  const pathname = window.location.pathname;

  const user = JSON.parse(localStorage.getItem('user'));

  const forms = user?.forms || [];

  // A menu form links to a list page (/dashboard/order/list); its detail and
  // edit pages (/dashboard/order/123) belong to the same form, so they are
  // matched on the section too. Without that they sent no form-id and the
  // backend skipped the permission check for them entirely. The longest
  // (most specific) match wins.
  let matchedForm = null;
  let matchedLength = -1;
  forms.forEach((form) => {
    const resolvedPath = resolveDynamicPath(form.formLink, PATH_DASHBOARD);
    if (typeof resolvedPath !== 'string') return;
    const section = resolvedPath.replace(/\/list$/, '');
    // Prefix-match only a real section (/dashboard/order), never /dashboard
    // itself, which would otherwise claim every page that has no form.
    const isSection = section.split('/').filter(Boolean).length >= 2;
    const isMatch = pathname === resolvedPath || (isSection && pathname.startsWith(`${section}/`));
    if (isMatch && section.length > matchedLength) {
      matchedForm = form;
      matchedLength = section.length;
    }
  });

  const formId = matchedForm?.formId;

  // Add to headers ✅
  if (formId) {
    config.headers['form-id'] = formId;
  }

  return config;
});


axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("interceptor error", error);
    // Don't use hooks here - let the calling component handle error display
    return Promise.reject((error.response && error.response.data) || 'Something went wrong');
  }
);

export default axiosInstance;
